<template>
  <div id="ui-ux" class="img-container">
    <img src="@/assets/intro/ui-ux/hamburger.png" class="hamburger" alt="">
    <img src="@/assets/intro/ui-ux/button.png" class="button" alt="">
    <img src="@/assets/intro/ui-ux/paragraph.png" class="paragraph" alt="">
    <img src="@/assets/intro/ui-ux/input.png" class="input" alt="">
    <img src="@/assets/intro/ui-ux/loading.png" class="loading" alt="">
    <img src="@/assets/intro/ui-ux/phone.png" class="phone" alt="">
  </div>
</template>

<script>
import backgroundAnimation from './background-animation'

export default {
  name: 'UiUxBackground',
  mixins: [backgroundAnimation],
  mounted () {
    this.backgroundAnimation(
      'ui-ux',
      0.1,
      2,
      'display-ui-ux-background'
    )
  }
}
</script>

<style scoped lang="sass">
  @tailwind utilities

  $medium-container-height: 13rem
  $xl-container-height: 17rem

  .img-container
    @apply absolute half-t -translate-y-50 w-screen
    height: 11rem
    left: $mobile-background-transition-distance * 3
    & > *
      @apply absolute
    @screen md
      height: $medium-container-height
    @screen xl
      height: $xl-container-height

  .hamburger
    bottom: calc(100% + 9rem)
    width: 70vw
    left: 2rem
    @screen sm-l
      bottom: 80%
      width: 18rem
      left: initial
      right: -10%
    @screen md
      bottom: calc(100% + 12rem)
      width: 25rem
      left: 10%
    @screen lg
      width: 25rem
      left: 15%
      bottom: calc(100% + 2rem)
    @include csh-lg(1000)
      width: 22rem
      bottom: calc(100% + 6rem)
      left: 40%
    @screen xl
      width: 30rem
      left: 0%
      bottom: calc(100% + 16rem)
    @screen xxl
      width: 40rem
      bottom: calc(100% + 3rem)
    @screen xxxl
      width: 34rem
      left: -3%
      right: initial
      bottom: calc(100% + 5rem)

  .button
    @apply hidden
    @screen sm-l
      @apply block
      width: 18rem
      bottom: calc(100% + 2rem)
      left: 5%
    @screen md
      @apply block
      width: 18rem
      left: 2rem
      bottom: calc(100% + 2rem)
    @screen lg
      left: 56%
    @include csh-lg(1000)
      left: 5%
    @screen xl
      width: 22rem
      left: 50%
    @include csh-xl(1000)
      left: 5%
      /*right: 5%*/
    @screen xl
      left: -3%
    @screen xxl
      bottom: calc(100% + 7rem)
      width: 28rem
      left: initial
      right: 5%
    @screen xxxl
      right: initial
      bottom: 2rem
      left: -5%

  .paragraph
    @apply hidden
    @include csh-lg(1000)
      @apply block
      width: 45rem
      bottom: calc(100% + 20rem)
      left: 5%
    @screen xl
      @apply block -translate-x-50
      top: calc(100% + 11rem)
      left: 42%
      width: 52rem
    @screen xxl
      transform: none
      top: calc(100% + 12rem)
      left: 3%
      width: 54rem
    @screen xxxl
      top: calc(100% + 10rem)
      width: 60rem

  .input
    min-width: 135vw
    top: calc(100% + 10rem)
    right: -50%
    @screen sm-l
      min-width: initial
      width: 35rem
      top: 90%
      right: -35%
    @screen md
      @apply half-r translate-x-50
      min-width: initial
      width: 90%
      top: calc(100% + 7rem)
    @screen lg
      width: 43rem
    @include csh-lg(900)
      top: calc(100% + 12vh)
    @include csh-lg(1000)
      top: calc(100% + 12rem)
    @screen xl
      transform: none
      top: initial
      bottom: calc(100% + 5rem)
      width: 46rem
      left: 45%
    @screen xxl
      left: 10%
      bottom: calc(100% + 26rem)
      width: 58rem
    @screen xxxl
      left: initial
      right: 3%
      bottom: calc(100% + 5rem)

  .loading
    @apply half-l -translate-x-50
    width: 90vw
    top: calc(100% + 3rem)
    @screen sm-l
      width: 55vw
      top: calc(100% + 1rem)
      transform: none
      left: 5%
    @screen md
      width: 60vw
      top: calc(100% + 2rem)
    @screen lg
      width: 40%
    @include csh-lg(1000)
      width: 55%
      top: calc(100% + 3rem)
    @screen xl
      width: 27rem
      bottom: 55%
      left: 10%
      transform: none
    @screen xxl
      @apply half-l -translate-x-50
      right: initial
      width: 38rem
      bottom: 23%
    @screen xxxl
      left: 43%
      transform: none

  .phone
    width: 81vw
    right: -25%
    bottom: 70%
    @screen sm-l
      @apply hidden
    @screen md
      bottom: 65%
      width: 28rem
      right: -5%
    @screen lg
      width: 25rem
      bottom: 0
      right: -10%
    @include csh-lg(1000)
      bottom: 64%
      right: -5%
    @screen xl
      width: 27rem
      bottom: -5rem
      right: -2%
    @screen xxl
      width: 35rem
      bottom: initial
      top: calc(100% + 7rem)
      right: 3%
    @screen xxxl
      top: 12rem
</style>
